import { SVGProps } from 'react'

export const MessageNoBg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="none" viewBox="0 0 21 20" {...props}>
    <path
      fill="currentColor"
      d="M17.167 1.667H3.833c-.916 0-1.658.75-1.658 1.667l-.008 15L5.5 15h11.667c.916 0 1.666-.75 1.666-1.666v-10c0-.917-.75-1.667-1.666-1.667zm-1.667 10h-10V10h10v1.667zm0-2.5h-10V7.5h10v1.667zm0-2.5h-10V5h10v1.667z"
    ></path>
  </svg>
)
